import { default as MuiDialogTitle, DialogTitleProps } from '@mui/material/DialogTitle'
import * as React from 'react'

const DialogTitle: React.FC<React.PropsWithChildren<DialogTitleProps>> = ({ children, ...props }) => (
  <MuiDialogTitle {...props}>{children}</MuiDialogTitle>
)

export default DialogTitle
